import {TextField} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/DoneAll";
import ClearIcon from "@material-ui/icons/DeleteOutline";
import Chip from "@material-ui/core/Chip";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import {withTranslation} from "react-i18next";
import NotificationErrorIcon from "@material-ui/icons/Error";
import integrationDetails from "../../../models/IntegrationModel";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import formStyle from "../../../assets/jss/custom-components/formStyle";


class Headers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: this.props.component.state.headerName,
            value: this.props.component.state.headerValue,
            selectedItem: null
        };
    }


    handleChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            [name]: value
        });
    };



    editItem = (item) => {
        const { component } = this.props;

        //Find index of specific object using findIndex method.
        let index = integrationDetails.actionDetail.headers.findIndex((val => val.id === item.id));
        integrationDetails.actionDetail.headers[index].isEditing = true;

        component.setState({
            headers: integrationDetails.actionDetail.headers,
            disabledItem: true
        });

        this.setState({
            selectedItem: item,
            name: item.name,
            value: item.value,
        })
    };


    saveItemChanges = (item) => {
        const { component, t } = this.props;

        if (this.state.name !== ""  || this.state.value !== "") {
            //Find index of specific object using findIndex method.
            let index = integrationDetails.actionDetail.headers.findIndex((val => val.id === item.id));

            integrationDetails.actionDetail.headers[index].name = this.state.name;
            integrationDetails.actionDetail.headers[index].value = this.state.value;
            integrationDetails.actionDetail.headers[index].isEditing = false;

            this.setState({
                selectedItem: null,
                name: "",
                value: "",
            });
            component.setState({
                headers: integrationDetails.actionDetail.headers,
                disabledItem: false,
                disableField: false,
            });
        } else {
            component.showNotification(t('INVALID_ITEM_MSG'), "danger", NotificationErrorIcon);
        }
    };


    deleteItem = (item) => {
        const { component } = this.props;

        let index = integrationDetails.actionDetail.headers.findIndex(val => val.id === item.id);
        integrationDetails.actionDetail.headers.splice(index, 1);
        component.setState({
            headers: integrationDetails.actionDetail.headers,
            disabledItem: false,
            disableField: false
        });

        this.setState({ selectedItem: null, name: '', value: '' });
    };



    render() {
        const { classes, items, t } = this.props;
        const { selectedItem, name, value } = this.state;
        return (
            <div>
                {
                    items.map((item, key) => (
                        <div key={key} className={classes.scheduleContainer}>
                            {
                                item.isEditing
                                    ? (
                                        <GridContainer>
                                            <GridItem xs={12} sm={7} md={7}>
                                                <TextField
                                                    value={name}
                                                    id="name"
                                                    name="name"
                                                    placeholder={t('NAME_TEXT')}
                                                    autoFocus={true}
                                                    fullWidth={true}
                                                    onChange={this.handleChangeValues}
                                                    className={classes.modifierItemNameContainer}
                                                    margin="dense"
                                                    variant="outlined"/>
                                            </GridItem>
                                            <GridItem xs={10} sm={5} md={5}>
                                                <TextField
                                                    value={value}
                                                    id="value"
                                                    name="value"
                                                    placeholder={t('VALUE_TEXT')}
                                                    onChange={this.handleChangeValues}
                                                    className={classes.surchargeContainer}
                                                    margin="dense"
                                                    variant="outlined"/>
                                                <Tooltip id="tooltip-save" title={t('BTN_SAVE_CHANGES')} placement="top-start">
                                                    <IconButton
                                                        size={"small"}
                                                        onClick={() => this.saveItemChanges(item)}
                                                        style={{marginLeft: 25, marginTop:13}}>
                                                        <SaveIcon className={classes.iconButtonGreen} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip id="tooltip-delete" title={t('DELETE_ITEM_TEXT')} placement="top-start">
                                                    <IconButton
                                                        size={"small"}
                                                        onClick={() => this.deleteItem(item)}
                                                        style={{marginTop:13}}>
                                                        <ClearIcon className={classes.iconButtonRed} />
                                                    </IconButton>
                                                </Tooltip>
                                            </GridItem>
                                        </GridContainer>
                                    ) : (
                                        <GridContainer>
                                            <GridItem xs={12} sm={7} md={7}>
                                                <Chip label={`"${item.name}": "${item.value}"`} style={{maxWidth: "350px"}}/>
                                            </GridItem>
                                            <GridItem xs={10} sm={5} md={5}>
                                                <Tooltip id="tooltip-edit" title={t('EDIT_TEXT')} placement="top-start">
                                                    <IconButton
                                                        size={"small"}
                                                        onClick={() => this.editItem(item)}
                                                        disabled={selectedItem != null && selectedItem !== item}
                                                        style={{marginLeft: 25}}>
                                                        <EditIcon className={classes.iconButtonBlue} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip id="tooltip-delete" title={t('DELETE_TEXT')} placement="top-start">
                                                    <IconButton
                                                        size={"small"}
                                                        disabled={selectedItem != null && selectedItem !== item}
                                                        onClick={() => this.deleteItem(item)}>
                                                        <ClearIcon className={classes.iconButtonRed} />
                                                    </IconButton>
                                                </Tooltip>
                                            </GridItem>
                                        </GridContainer>
                                    )
                            }
                        </div>
                    ))
                }
            </div>
        );
    }

}

Headers.propTypes = {
    classes: PropTypes.object,
    component: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired
};

export default withRouter(withStyles(formStyle)(withTranslation()(Headers)));
